import { ROLE_LABEL } from 'src/constants';

const LabelRole = ({ role }) => {
    const role_label = ROLE_LABEL[role] ?? { text: '', color: '' };
    return <span className={`badge bg-${role_label.color}`}>{role_label.text}</span>;
};

export default LabelRole;
